import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordFieldsMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('inputPassword');
    const confirmPassword = control.get('inputPasswordConfirm');
    return password && confirmPassword && password.value !== confirmPassword.value ? { passwordFieldsMatchError: true } : null;
};
